var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Home",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 29",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Home",
    d: "M11.049 25.117v-3.711a1.714 1.714 0 011.709-1.708h3.473a1.714 1.714 0 011.72 1.708v3.7a1.488 1.488 0 001.482 1.482h2.369a4.181 4.181 0 002.952-1.207 4.12 4.12 0 001.224-2.928V11.917a2.988 2.988 0 00-1.082-2.3l-8.048-6.385a3.764 3.764 0 00-4.782.085L4.189 9.623a2.99 2.99 0 00-1.168 2.294v10.52a4.161 4.161 0 004.176 4.146h2.316a1.488 1.488 0 001.055-.427 1.466 1.466 0 00.438-1.039z"
  })));
}

export default SvgHome;